import { io, Socket } from "socket.io-client";
import queryClient from "@services/query-client";
import { getToken } from "../backend-api";
import { CacheKeyTypes } from "../cache";
import { ioEvents, ClientToServerEvents, ServerToClientEvents } from "@weepy/shared";
import { UserState } from "../rpc-client";
import { displayMessage } from "@src/utils";

const headersAndQuery: { [key: string]: string } = {
  t: getToken() || "",
  v: import.meta.env.VITE_VERSION || "",
};
export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(import.meta.env.VITE_BASE_URL as string, {
  autoConnect: false,
  path: "/socket",
  transports: ["websocket", "polling"],
  extraHeaders: headersAndQuery, // TODO: token changes/ user logout stop socket
  query: headersAndQuery,
});

// TODO: disconnect after x errors
socket.on("connect_error", (err) => {
  console.error("connect_error", "\n", err, "\n", JSON.stringify(err));
  if (err.message === "500" || err.message === "401") socket.disconnect();
});

let connectCount = 0;
let disconnected_at: number | null = null;
socket.on("connect", () => {
  connectCount++;
  // socket.sendBuffer = []; // empty the internal buffer upon reconnection
  // console.debug(`[Socket] connected${disconnected_at && `, was disconnected for: ${Date.now() - disconnected_at}`}`);
  if (connectCount !== 1 && disconnected_at && Date.now() - disconnected_at > 10000) {
    socket.emit(ioEvents.USER_STATE, (data) => onUserState(data));
  }
  disconnected_at = null;
});

socket.on("disconnect", () => (disconnected_at = Date.now()));
// socket.on("disconnect", (reason) => {
//   console.log(reason);
//   disconnected_at = Date.now();
// });

// Server to Client Event Handlers
// A listener is set up in AuthContext as well.
socket.onAny((evtName, b) => console.debug(`[SocketEvent]: ${evtName}`, b));
socket.on(ioEvents.FEED_UPDATED, () => onFeedUpdated());
socket.on(ioEvents.USER_STATE, (data) => onUserState(data));
socket.on(ioEvents.MESSAGE, (d) => {
  if (d.reload_page) return window.location.reload();
  if (d.prompt) return alert(d.message);
  displayMessage(d.message, d.type);
});

// Helper functions
const onUserState = (data: UserState) => queryClient.setQueryData<UserState>(CacheKeyTypes.UserState, data);

const onFeedUpdated = () => {
  const userState = queryClient.getQueryData<UserState>(CacheKeyTypes.UserState);
  if (userState?.has_unseen_feed === false) {
    userState.has_unseen_feed = true;
    queryClient.setQueryData<UserState>(CacheKeyTypes.UserState, userState);
    queryClient.invalidateQueries(CacheKeyTypes.Feed);
  }
};

export default socket;

// function onVisibilityChange (evt: DocumentEventMap['visibilitychange']) {
//   console.log("socket.client visibilitychange", document.visibilityState);
//   if (document.visibilityState === "visible") {
//     socket.io.reconnection(true);
//     socket.disconnected && socket.connect();
//   } else {
//     socket.io.reconnection(false);
//   }
// }
// document.addEventListener("visibilitychange", onVisibilityChange);
